export const INCREMENT = "INCREMENT";
export const DECREMENT = "DECREMENT";
export const BARCODE = "BARCODE";
export const SENDBARCODE = "SENDBARCODE";
export const UPDATEITEM = "UPDATEITEM";
export const UPDATEITEMFORM = "UPDATEITEMFORM";
export const FIND538A = "FIND538A";
export const UPDATEMESSAGE = "UPDATEMESSAGE";
export const LOGIN = "LOGIN";
